// extracted by mini-css-extract-plugin
export var animationContainer = "_n8-0";
export var footer = "_n8-1";
export var gray = "_n8-2";
export var lineItem = "_n8-3";
export var lineItemImage = "_n8-4";
export var lineItemInfo = "_n8-5";
export var lineItemText = "_n8-6";
export var lineItems = "_n8-7";
export var modalContent = "_n8-8";
export var options = "_n8-9";
export var orderName = "_n8-a";
export var refundAmount = "_n8-b";